import {
  AfterViewInit,
  Component,
  ComponentRef,
  input,
  OnDestroy,
  viewChild,
  ViewContainerRef,
} from '@angular/core';
import { AddLocationComponent } from '../../../../../locations/add-location/add-location.component';
import { IntelligenceModels } from '@models/intelligence.model';

/** Hosts the existing single-step Add Core form inside the Cmd+K result panel. */
@Component({
  selector: 'app-add-core-result',
  standalone: true,
  templateUrl: './add-core-result.component.html',
  styleUrl: './add-core-result.component.scss',
})
export class AddCoreResultComponent implements AfterViewInit, OnDestroy {
  public readonly request = input<IntelligenceModels.CoreProvisioning.AddCoreRequest | null>(null);

  private readonly container = viewChild('container', { read: ViewContainerRef });
  private componentRef: ComponentRef<AddLocationComponent> | null = null;

  public ngAfterViewInit(): void {
    if (!this.request() || !this.container()) return;
    this.componentRef = this.container()!.createComponent(AddLocationComponent);
    this.componentRef.changeDetectorRef.detectChanges();
  }

  public ngOnDestroy(): void {
    this.componentRef?.destroy();
  }
}
